import cx from 'classnames';

import TradeFeeContent from 'components/placeorder/partials/makerTakerPopup/TradeFeeContent';
import Render from 'components/render';
import { LOCALES } from 'constants/dateTime';
import { CURRENCY_TYPE } from 'constants/enums';
import { formatFiat } from 'helpers/currency';
import { convertFromUSDtoINR } from 'helpers/utils';
import i18n from 'i18n/config';
import { inrConversionRateSelector } from 'selectors/otherSelectors';
import { deltaCashSelectorUsd } from 'selectors/walletSelector';
import { useAppSelector } from 'storeHooks';

import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';

const deltaCashLabel = i18n.t('headerFooter:header.wallet.deltaCash');
const deltaCashPopOver = <TradeFeeContent />;

const DeltaCash = ({
  showAmount,
  className = '',
}: {
  showAmount: boolean;
  className?: string;
}) => {
  const deltaCashAmount = useAppSelector(deltaCashSelectorUsd);
  const inrConversionRate = useAppSelector(inrConversionRateSelector);
  const deltaCashFormattedInUSD = formatFiat(
    CURRENCY_TYPE.USD,
    Number(deltaCashAmount ?? 0),
    LOCALES.INDIA
  );

  const deltaCashFormattedInINR = formatFiat(
    CURRENCY_TYPE.INR,
    convertFromUSDtoINR(Number(deltaCashAmount ?? 0), inrConversionRate),
    LOCALES.INDIA
  );

  return (
    (<div
      className={cx(
        styles['label-value-container'],
        styles.accountValueCollapsableButton,
        className
      )}
      data-palette="DeltaCash">
      <div className={styles.label}>
        <TooltipWrapper title={deltaCashLabel} body={deltaCashPopOver} />
      </div>
      <div className={cx('flex-set flex--column', styles.value)}>
        <span className={styles.inr}>
          <Render when={showAmount} else="******">
            {deltaCashFormattedInINR}
          </Render>
        </span>
        <span className={styles.usd}>
          <Render when={showAmount} else="******">
            {deltaCashFormattedInUSD}
          </Render>
        </span>
      </div>
    </div>)
  );
};

export default DeltaCash;
